import Intercom from "@intercom/messenger-js-sdk";
import { useEffect } from "react";
import { INTERCOM_APP_ID } from "./constants";
import { getHost } from "@/lib/utils";
import { IntercomIcon } from "../icons";

function IntercomChatGuest() {
	const host = getHost();
	const isKashuOrPayova = host === "kashu" || host === "payova";

	useEffect(() => {
		if (!isKashuOrPayova) {
			return;
		}

		Intercom({
			app_id: INTERCOM_APP_ID,
			custom_launcher_selector: "#intercom-guest-launcher",
			hide_default_launcher: true,
		});
	}, [isKashuOrPayova]);

	if (!isKashuOrPayova) {
		return null;
	}

	return (
		<button
			id="intercom-guest-launcher"
			type="button"
			aria-label="Open chat"
			className="fixed z-[9999] flex h-12 w-12 items-center justify-center rounded-full bg-primary-600 text-white shadow-lg transition-transform hover:scale-105 active:scale-95 top-4 left-4 sm:top-6 sm:left-6 md:top-8 md:left-8"
		>
			<IntercomIcon className="w-6 h-6" />
		</button>
	);
}

export default IntercomChatGuest;
